import script from "./JimsTradeTracker.vue?vue&type=script&setup=true&lang=js"
export * from "./JimsTradeTracker.vue?vue&type=script&setup=true&lang=js"

import "./JimsTradeTracker.vue?vue&type=style&index=0&id=47e60a6d&lang=scss"

const __exports__ = script;

export default __exports__